/** Imports */
import superJson from 'superjson';
import {type AppRouter} from '@/server/api/root';
import {httpBatchLink, httpBatchStreamLink, splitLink} from '@trpc/client';


/** Stream every independent query result without changing mutation transport. */
export function createDashboardTransportLink(options: {
    url: string;
    fetch?: typeof fetch;
}) {
    const transportOptions = {
        url: options.url,
        transformer: superJson,
        fetch: (url: RequestInfo | URL, init?: RequestInit) => (
            (options.fetch ?? fetch)(url, {...init, credentials: 'include'})
        ),
    };
    return splitLink<AppRouter>({
        condition: (operation) => (operation.type === 'query'),
        true: httpBatchStreamLink<AppRouter>(transportOptions),
        false: httpBatchLink<AppRouter>(transportOptions),
    });
}
